import React, { useState, useMemo } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
} from 'react-native';
import { Store, Venue } from '@oolio-group/domain';
import Icon from '../../component/Icon/Icon';
import Search from '../../component/System/Search/Search';
import { styles } from './PairingScreen.styles';
import theme from '../../common/theme';

interface VenueAndStoreListProps {
  onSelect?: (venue: Venue, store: Store) => void;
  onSearch?: (searchString: string) => void;
  venuesData: Venue[];
  loading?: boolean;
}

const LocationsList: React.FC<VenueAndStoreListProps> = ({
  onSelect = () => undefined,
  venuesData,
  loading = false,
}: VenueAndStoreListProps) => {
  const [searchText, setSearchText] = useState('');

  const filteredVenues = useMemo(() => {
    const query = searchText.toLowerCase();
    return venuesData
      .filter(
        venue =>
          venue.name.toLowerCase().includes(query) ||
          venue.stores.some(store => store.name.toLowerCase().includes(query)),
      )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(venue => ({
        ...venue,
        stores: venue.stores
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name)),
      }));
  }, [searchText, venuesData]);

  return (
    <View style={styles.content}>
      <Text style={styles.title}>Select store to continue...</Text>
      <Search
        testID="search"
        maxLength={50}
        onChangeText={setSearchText}
        placeholder="Search venues or stores by name..."
        containerStyle={styles.search}
      />
      {loading ? (
        <View style={styles.loading}>
          <ActivityIndicator size={20} color={theme.palette.primary} />
        </View>
      ) : (
        <View style={styles.table}>
          <ScrollView>
            {filteredVenues.length > 0 ? (
              filteredVenues.map(venue => (
                <View key={venue.id} style={styles.group}>
                  <View style={styles.rowParent}>
                    <Text style={styles.textParent}>{venue.name}</Text>
                  </View>
                  {venue.stores.map(store => (
                    <TouchableOpacity
                      key={store.id}
                      style={styles.rowChild}
                      onPress={() => onSelect(venue, store)}
                    >
                      <Icon
                        color={theme.palette.mono500}
                        name="corner-down-right-alt"
                      />
                      <Text style={styles.textChild}>{store.name}</Text>
                      <Icon name="angle-right" color={theme.palette.mono500} />
                    </TouchableOpacity>
                  ))}
                </View>
              ))
            ) : (
              <View style={styles.loading}>
                <Text style={styles.emptyText}>No stores found.</Text>
              </View>
            )}
          </ScrollView>
        </View>
      )}
    </View>
  );
};

export default LocationsList;
